import React from 'react';
import {Button, Col, Row} from 'react-bootstrap';
//import {useHistory} from 'react-router-dom';
import {getToken} from "../../Utils/Common";

const ProjectBottonComponent = ({
                                    projectSetup, imagePaths, setProjectSetup, auftraggeberList,
                                    auftraggeberAddress,
                                    planerAddress,
                                    projectAddress,
                                    projectLeadDetails
                                }) => {

    //let history = useHistory();

    const [disableSaveButton, setDisableSaveButton] = React.useState(false)

    function goAhead(apidata) {
        let newAPIData = JSON.parse(JSON.stringify(apidata))
        let data = newAPIData.data
        delete data.projectAddress.email
        delete data.projectAddress.fax



        if (data.projectName !== "" &&
            data.customerReference !== "" &&
            data.customerIdentificator !== "" &&
            (Object.values(data.projectAddress).every(val => val !== "")
            ||Object.values(data.projectAddress).every(val => val === "")
            )
            &&
            (Object.values(data.planerAddress).every(val => val !== "")
            ||Object.values(data.planerAddress).every(val => val === "")
            )
            &&
            (Object.values(data.auftraggeberAddress).every(val => val !== "")
            ||Object.values(data.auftraggeberAddress).every(val => val === "")
            )
            &&
            data.projectLeadDetails.every((e)=>Object.values(e).every(val => val !== ""))

        ) {
            return true
        } else {
            return false
        }
    }

    return (

        <Row>

            <Col sm={1}></Col>

            <Col>

                <Button

                    disabled={projectSetup.projectName === "" || projectSetup.customerIdentificator === "" || disableSaveButton}
                    className="handwai-btn-create"
                    onClick={async () => {

                        setDisableSaveButton(false)

                        if (projectSetup.projectID === "") {

                            let projectID

                            projectID = Math.floor(Math.random() * 1000000000000000000)

                            projectSetup.projectID = projectID.toString()

                            let projectSetupCopy = {...projectSetup}

                            projectSetupCopy.projectID = projectID.toString()

                            setProjectSetup(projectSetupCopy)
                        } else {

                            let projectPlanAlreadyExists = ""
                            projectSetup.planData.forEach((planDataObject, index) => {

                                    if (planDataObject.objectPath === undefined) {

                                        projectPlanAlreadyExists = index


                                    }
                                }
                            )

                            for (let k = 0; k < imagePaths.length; k++) {

                                let selectedImagePath = imagePaths[k]

                                let projectSetupCopy = {...projectSetup}

                                let updatedPlanData = projectSetupCopy.planData.map((planDataObject, index) => {

                                    if (index === projectPlanAlreadyExists) {

                                        planDataObject.objectPath = selectedImagePath

                                    }
                                })

                                projectSetupCopy.planData = updatedPlanData

                                setProjectSetup(projectSetupCopy)


                                projectPlanAlreadyExists = projectPlanAlreadyExists + 1
                            }
                        }
                        projectSetup['auftraggeberList'] = auftraggeberList;
                        projectSetup['projectLeadDetails'] = projectLeadDetails;
                        projectSetup['planerAddress'] = planerAddress;
                        projectSetup['auftraggeberAddress'] = auftraggeberAddress;
                        projectSetup['projectAddress'] = projectAddress;
                        let apiBody = {
                            "token": getToken(),
                            "data": projectSetup
                        }


                        if (goAhead(apiBody)) {
                            //let serverResponse = await fetch("https://yv3616bv8b.execute-api.eu-west-3.amazonaws.com/dev/v1/app/createprojectplan", {

                            let serverResponse = await fetch(process.env.REACT_APP_BACKEND_API_URI + "mobileappbackend/createupdate_project", {

                                method: 'POST',
                                headers: {
                                    'Content-type': 'application/json',
                                },
                                body: JSON.stringify(apiBody),
                            })
                                .then((response) => response.json())
                                .catch((error) => {
                                    console.error('Error:', error);
                                })

                            if (serverResponse.status === 200) {

                                alert("Projekt erfolgreich gespeichert")

                                //history.push(process.env.REACT_APP_FRONTEND_PATH_PROJECTSOVERVIEWPAGE)

                                //window.location.reload();

                            } else {

                                alert("Projekt konnte nicht gespeichert werden")


                            }
                        } else {
                            alert("Bitte alle ausfüllen")
                        }
                    }


                    }


                >Speichern</Button>

            </Col>

        </Row>

    )

}

export default ProjectBottonComponent;